import { Component } from '@angular/core';

@Component({
  selector: 'jb-overview-skeleton',
  templateUrl: './overview-skeleton.component.html',
})
export class OverviewSkeletonComponent {}
